enum EnumChargeOptionsDescriptionPattern {
  INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT_FEE_PERCENTAGE = 'INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT_FEE_PERCENTAGE',
  INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT = 'INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT',
  TYPE_INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT = 'TYPE_INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT',
  TYPE_INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT_FEE_PERCENTAGE = 'TYPE_INSTALLMENT_NUMBER_INSTALLMENT_AMOUNT_FEE_PERCENTAGE',
}

export default EnumChargeOptionsDescriptionPattern;
